<template>
    <TableFilter :filter-refs="$refs"
                 @apply-filter="applyFilter"
    >
        <div class="filter_item">
          <TextFilter :label-text="this.$t('common.lastName')"
                      columnName="lastName"
                      ref="filter_lastName"
          ></TextFilter>
          <TextFilter :label-text="this.$t('common.firstName')"
                      columnName="firstName"
                      ref="filter_firstName"
          ></TextFilter>
          <TextFilter :label-text="this.$t('common.email')"
                      columnName="email"
                      ref="filter_email"
          ></TextFilter>
          <TextFilter :label-text="this.$t('common.phone')"
                      columnName="phone"
                      ref="filter_phone"
          ></TextFilter>
          <EnumFilter :label-text="this.$t('common.type')"
                      columnName="userLevel"
                      :enumDef="enumDef.userLevel"
                      ref="filter_userLevel"
          ></EnumFilter>
          <EnumFilter :label-text="this.$t('common.status')"
                      columnName="userStatus"
                      :enumDef="enumDef.userStatus"
                      ref="filter_userStatus"
          ></EnumFilter>
        </div>
    </TableFilter>
</template>

<script>
import TableFilter from "@/components/newFilter/TableFilter";
import TextFilter from "@/components/newFilter/TextFilter";
import EnumFilter from "@/components/newFilter/EnumFilter";
import {enumDef} from "@/common/enumDefs";

export default {
    components: {
      EnumFilter,
      TextFilter,
        TableFilter
    },
    data() {
        return {
          enumDef: enumDef,
        };
    },
    methods: {
        applyFilter(filters) {
            this.$emit("apply-filter", filters);
        }
    }
};
</script>